import { render, staticRenderFns } from "./ServiceLayout.vue?vue&type=template&id=e6a16be4&"
import script from "./ServiceLayout.vue?vue&type=script&lang=js&"
export * from "./ServiceLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports